module.exports = __webpack_public_path__ + "img/head_1.423bb371.png";